// extracted by mini-css-extract-plugin
export default {"container":"Settings_container__EikEP","password":"Settings_password__gwA5z"};